import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  total: 0
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      // Check if item already exists in cart
      const existingItem = state.items.find(item => item.voiceId === action.payload.voiceId);

      if (!existingItem) {
        state.items.push(action.payload);
        state.total += action.payload.price;
      }
    },
    removeFromCart: (state, action) => {
      const index = state.items.findIndex(item => item.voiceId === action.payload);
      if (index !== -1) {
        state.total -= state.items[index].price;
        state.items.splice(index, 1);
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.total = 0;
    }
  }
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;

// Selectors
// Stable empty-array fallback — a fresh `[]` per call makes useSelector warn
// ("returned a different result … same parameters") and rerender needlessly.
const EMPTY_ARRAY = Object.freeze([]);
export const selectCartItems = (state) => state.user.cart?.items || EMPTY_ARRAY;
export const selectCartTotal = (state) => state.user.cart?.total || 0;
export const selectCartItemCount = (state) => state.user.cart?.items?.length || 0;
export const selectIsInCart = (voiceId) => (state) =>
  state.user.cart?.items?.some(item => item.voiceId === voiceId) || false;

export default cartSlice.reducer;
